import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {xatbotRoutes} from '@features/xatbot/xatbot.routes';
import {workspaceRoutes} from '@features/workspace/workspace.routes';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedMatModule} from '@shared/shared-mat.module';
import {SharedModule} from '@shared/shared.module';
import {WorkspaceHandler} from '@features/workspace/handlers/workspace.handler';
import {WorkspaceDynamicComponentHelper} from '@features/workspace/workspace-dynamic-component-helper';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {WorkspacePlatformApiProvider} from '@features/workspace/workspace-platform-api-provider';
import { WorkspaceSolutionsComponent } from './components/workspace-solutions/workspace-solutions.component';
import { WorkspaceUsersComponent } from './components/workspace-users/workspace-users.component';
import { WorkspaceFailureBannerComponent } from './components/workspace-failure-banner/workspace-failure-banner.component';
import {ManageWorkspaceSolutionCommandHandler} from '@features/workspace/handlers/manage-workspace-solution-command-handler';



@NgModule({
  declarations: [
    WorkspaceSolutionsComponent,
    WorkspaceUsersComponent,
    WorkspaceFailureBannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(workspaceRoutes),
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    SharedMatModule,
    SharedModule
  ]
})
export class WorkspaceModule {
  constructor(private commandService: CommandService,
              private workspaceHandler: WorkspaceHandler,
              private platformApiProvider: PlatformApiProvider,
              private manageWorkspaceSolutionCommandHandler: ManageWorkspaceSolutionCommandHandler) {
    platformApiProvider.registerAtTop(new WorkspacePlatformApiProvider());
    WorkspaceDynamicComponentHelper.init();
    WorkspaceDynamicComponentHelper.register('WorkspaceHandler', workspaceHandler);
    WorkspaceDynamicComponentHelper.register('ManageWorkspaceSolutionCommandHandler', manageWorkspaceSolutionCommandHandler);
    const workspaceCommand = new PlatformCommand('WorkspaceToolLinkCommand', Api.AdminPanel);
    workspaceCommand.projectId = '[PROJECT_ID]';
    commandService.registrPlatformLinkCommand('/workspace', workspaceCommand);
  }
}
